
// Rohit Sir code

import React, { useContext, useEffect, useState } from "react";
import "./allmeetings.css";
import { BsEye } from "react-icons/bs";
import { SlPencil } from "react-icons/sl";
import { AiOutlineDelete } from "react-icons/ai";
import { Url } from "../../../../../constants/ApiUrlConstants";
import { DELETE, POST, PUT } from "../../../../Common/HttpMethods/HttpMethods";
import { contextData } from "../../../../../context/ContextProvider";
import moment from "moment";
import { red } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";
import { AiOutlineRight, AiOutlineClose } from 'react-icons/ai';
import FailModal from "../../../../Common/Popups/FailModal";
import SuccessModal from "../../../../Common/Popups/SuccessModal";
import CancelReason from "../../../../Common/Popups/CancelReason";
import { IoPersonCircleOutline } from "react-icons/io5";
import { FaArrowRight } from "react-icons/fa6";
import { MdSchedule } from "react-icons/md";
import Modal from "react-modal";
import { BsDownload } from 'react-icons/bs'
import { Cuurent_EMAIL, Cuurent_USERNAME, GeneratePDF, extractMeetingData, extractTextFromHtml, firstLineTextFromHtml, getAllToFromOptionalEmailArr, getEmailClassification, handleCancel, handleOverflowCheck, sanitizeHtml, stripHtmlTags, useOverflowCheck } from "../../../../CommonCase/CommonFunctions";
import UpcomingMeetingModal from "../../../../CommonCase/UpcomingMeetingModal";
import CancelledMeetingModal from "../../../../CommonCase/CancelledMeetingModal";

export const reasonChange = (e, setReason) => {
  setReason(e.target.value)
}

export const handleCloseSuccessModal = (setOpenSuccessModal) => {
  setOpenSuccessModal(false)
}

export const handleAllMCloseOnRequest = (setAllUpcommingMeetOpenView, setAgendaDivHeight, setMsgDivHeight, setAttendeesDivHeight) => { setAllUpcommingMeetOpenView(false); setAgendaDivHeight(false); setMsgDivHeight(false); setAttendeesDivHeight(false) }

export const handleCloseFailModel = (setOpenFailModal) => {
  setOpenFailModal(false);
}

export const handleSessionExpClose = (navigate, setActive) => {
  sessionStorage.clear();
  navigate('/login');
  setActive('tab1');
}

export const handleCloseFullView = (setFullView) => {
  setFullView((prevState) => ({ viewMore: false, isClicked: false, typeOfMeeting: '', viewMoreAttendees: false, data: {} }));
}

export const handleAllMCloseModalOnRequest = (setAllCancelMeetOpenView, setAgendaDivHeightCancel) => {debugger
   setAllCancelMeetOpenView(false); setAgendaDivHeightCancel(false); }


export function isOverflowing(element) {
  return element?.scrollHeight > element?.clientHeight || element?.scrollWidth > element?.clientWidth;
}

export const handleCloseFullViewCancel = (setFullViewCancel) => {
  setFullViewCancel((prevState) => ({ viewMore: false, isClicked: false, typeOfMeeting: '', data: {} }));
}

export const handleCloseCancleModal = (setOpenCancelModal) => {
  setOpenCancelModal(false)
}


export const handleDeleteMeeting = async ({
  setOpenDeleteModal,
  setLoading,
  meetingToDelete,
  DELETE,
  Url,
  token,
  setSuccessMessage,
  setOpenSuccessModal,
  toggleForCount,
  setToggleForCount,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal
}) => {
  setOpenDeleteModal(false);

  try {
    setLoading(true);
    const cancelMeetingResp = await DELETE(Url.deleteMeeting.replace("{mid}", `${meetingToDelete.id}`), token);

    if (cancelMeetingResp.SUCCESS) {
      setLoading(false);
      setSuccessMessage('Meeting Deleted Successfully.');
      setOpenSuccessModal(true);
      setToggleForCount(!toggleForCount);
    }
    else if (cancelMeetingResp.STATUS === 401) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else if (cancelMeetingResp.STATUS === 400) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else if (cancelMeetingResp.STATUS === 403) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else if (cancelMeetingResp.STATUS === 404) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else if (cancelMeetingResp.STATUS === 500) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }
    else {
      setLoading(false);
      setFailMessage('Failed to delete meeting');
      setOpenFailModal(true);
    }
  }
  catch (error) {
    setLoading(false);
    setFailMessage('Failed to delete meeting');
    setOpenFailModal(true);
  }
};

export const handleViewMeeting = (meetingType, meeetingData, setViewPastMeeting, setFullView) => {
  switch (meetingType) {
    case "Past":
      setViewPastMeeting({ isView: true, meetingId: meeetingData?.mid });
      break;
    case "Upcoming":
      const { meetingSubject, mid, startDate, startTime, endTime, emailDetails, meetingAgenda } = meeetingData;

      const data = {
        attendees: (!emailDetails[0]?.attendees) ? [] : emailDetails[0]?.attendees?.split(","),
        agenda: !meetingAgenda ? [] : meetingAgenda?.split("\n"),
        title: !meetingSubject ? "" : meetingSubject,
        dateAndTime: startDate.length === 0 ? "" : `${startDate[0] - startDate[1] - startDate[2]} , ${startTime} - ${endTime}`
      };

      setFullView((prevState) => ({
        viewMore: false,
        viewMoreAttendees: false,
        isClicked: true,
        typeOfMeeting: '',
        data
      }));
      break;
    case "Cancelled":
      break;
    default:
      break;
  }
};

export const handleEditMeeting = (navigate, meetingType, meetingId, hasAccess, usermail) => {
  switch (meetingType) {
    case "Past":
      navigate("/main/meetings/edit-past-meeting", { state: { meetingId: meetingId } });
      break;
    case "Upcoming":
      navigate("/main/meetings/setupmeeting", { state: { meetingId: meetingId, flow: "UpcomingMeetings", upcomingMeetingEdit: true } });
      break;
    case "Cancelled":
      navigate("/main/meetings/setupmeeting", { state: { meetingId: meetingId, flow: "CancelledMeetings", cancelledMeetingEdit: true } });
      break;
    default:
      break;
  }
};


// Exporting the function to use in tests
export const getDashboardData = async ({
  setLoading,
  setData,
  setDataCopy,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal,
  POST,
  Url,
  token,
  selectedFromDate,
  selectedToDate
}) => {

  let allMeetingsBody = {
    fromDate: moment(selectedFromDate).format("YYYY-MM-DD"),
    toDate: moment(selectedToDate).format("YYYY-MM-DD"),
    meetType: "All",
  };

  try {
    setLoading(true);
    let AllMeetingsResp = await POST(
      Url.getAllTypeOfMeetingWithCount,
      token,
      allMeetingsBody
    );

    if (AllMeetingsResp.SUCCESS) {
      let a = AllMeetingsResp?.DATA?.allMeeting;
      setData(a);
      setDataCopy(a);
      setLoading(false);
    } else if (AllMeetingsResp.STATUS === 401) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (AllMeetingsResp.STATUS === 500) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else if (AllMeetingsResp.STATUS === 400) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else if (AllMeetingsResp.STATUS === 403) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else if (AllMeetingsResp.STATUS === 404) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }  else {
      setLoading(false);
      setFailMessage("Failed to fetch all meetings");
      setOpenFailModal(true);
    }
  } catch (error) {
    setLoading(false);
    setFailMessage("Failed to fetch all meetings");
    setOpenFailModal(true);
  }
  setLoading(false);
};


export const handleOpenFullView = (
  meetingData,
  setAllUpcommingMeetOpenView,
  setFullView,
  setLoading,
  extractMeetingData
) => {
  setAllUpcommingMeetOpenView(true);

  const data = extractMeetingData(meetingData);

  setFullView((prevState) => ({
    viewMore: false,
    isClicked: false,
    viewMoreAttendees: false,
    typeOfMeeting: meetingData?.typeOfMeeting,
    data,
  }));

  setLoading(true);

  setTimeout(() => {
    setLoading(false);
  }, 1100);
};


// utils.js (or any suitable file)
export const handleOpenFullViewCancel = (
  meeetingData,
  setAllCancelMeetOpenView,
  setFullViewCancel,
  setLoading,
  extractMeetingData
) => {
  setAllCancelMeetOpenView(true);

  const {
    meetingSubject,
    mid,
    startDate,
    startTime,
    endTime,
    emailDetails,
    meetingAgenda,
    cancelReason,
    cancelledByName,
  } = meeetingData;

  const data = extractMeetingData(meeetingData);

  setFullViewCancel((prevState) => ({
    viewMore: false,
    isClicked: false,
    typeOfMeeting: "",
    data,
  }));

  setLoading(true);

  setTimeout(() => {
    setLoading(false);
  }, 1100);
};


export const handleMeetingClick = ({
  item,
  handleViewMeeting,
  handleOpenFullView,
  handleOpenFullViewCancel,
  setViewPastMeeting,
  setFullView,
  setAllUpcommingMeetOpenView,
  setAllCancelMeetOpenView,
  setFullViewCancel,
  setLoading,
  extractMeetingData,
}) => {
  if (item?.typeOfMeeting === "Past" && item?.meetingSummary) {
    handleViewMeeting(
       item?.typeOfMeeting,
       item,
      setViewPastMeeting,
      setFullView,
    );
    
  } else if (item?.typeOfMeeting === "Upcoming") {
    handleOpenFullView(
      item,
      setAllUpcommingMeetOpenView,
      setFullView,
      setLoading,
      extractMeetingData
    );
  } else if (item?.typeOfMeeting === "Cancelled") {
    handleOpenFullViewCancel(
      item,
      setAllCancelMeetOpenView,
      setFullViewCancel,
      setLoading,
      extractMeetingData
    );
  }
};


export const processMeetingClick = ({
  item,
  from,
  navigate,
  hasAccess,
  usermail,
  handleEditMeeting,
}) => {
  if (item?.typeOfMeeting === "Past") {
    if (hasAccess(item)) {
      handleEditMeeting(navigate, item.typeOfMeeting, item.mid, hasAccess, usermail);
    }
  } else if (from[0]?.participantEmail === usermail) {
    handleEditMeeting(navigate, item.typeOfMeeting, item.mid, hasAccess, usermail);
  }
};


export const handleMeetingActions = ({
  item,
  from,
  usermail,
  setFailMessage,
  setOpenCancelModal,
  setIdToCancelMeeting,
  setCancelMeetingName,
  setOpenDeleteModal,
  setMeetingToDelete,
  GeneratePDF,
}) => {
  if (
    item &&
    item.emailDetail &&
    item.emailDetail.length > 0 &&
    from[0]?.participantEmail === usermail
  ) {
    if (item.typeOfMeeting === "Upcoming") {
      setFailMessage("Are you sure you want to cancel this meeting?");
      setOpenCancelModal(true);
      setIdToCancelMeeting(item.mid);
      setCancelMeetingName(item.meetingSubject);
    } else if (item.typeOfMeeting === "Cancelled") {
      setFailMessage("Are you sure you want to delete this meeting?");
      setOpenDeleteModal(true);
      setMeetingToDelete({ id: item.mid, type: item.typeOfMeeting });
    }
    // else{
    //   setFailMessage("Are you sure you want to delete this meeting?");
    //   setOpenDeleteModal(true);
    //   setMeetingToDelete({ id: item.mid, type: item.typeOfMeeting });
    // }
  }

  if (item?.typeOfMeeting === "Past") {
    if (item?.meetingSummary) {
      GeneratePDF(item?.mid, item?.momVersion);
    }else{
      setFailMessage('Failed to GeneratePDF');
    }
  }
};

export const hasAccess = (props) => {
  var usermail = Cuurent_EMAIL();
  const { allFullNamesArr, allEmailIdArr } = getAllToFromOptionalEmailArr(props?.participantsList);
  if (allEmailIdArr.includes(usermail)) {
    return true;
  }
  return false;
};

export const handleSearch = (inp, dataCopy, setData) => {

  if (!dataCopy || dataCopy.length === 0) {
    return;
  }

  setData(
    dataCopy.filter((i) => {
      return i?.meetingSubject?.toLowerCase().includes(inp?.toLowerCase());
    })
  );
};

const AllMeetings = ({ selectedToDate, selectedPeriod, searchInp, selectedFromDate, toggleForCount, setToggleForCount }) => {

  const navigate = useNavigate();


  const username = Cuurent_USERNAME();
  const usermail = Cuurent_EMAIL()
  let token = sessionStorage.getItem('TOKEN');


  const { setLoading, setViewPastMeeting, setActive } = useContext(contextData);

  //  ---------------------------------------------------------------------------Data States------------------------------------------------------------------------
  const [data, setData] = useState();
  const [dataCopy, setDataCopy] = useState();
  const [sessionExpiredModal, setSessionExpiredModal] = useState(false)
  const [AllcancelMeetOpenView, setAllCancelMeetOpenView] = useState(false)
  const [AllUpcommingMeetOpenView, setAllUpcommingMeetOpenView] = useState(false)




  const [fullView, setFullView] = useState({
    isClicked: false,
    viewMore: false,
    viewMoreAttendees: false,
    typeOfMeeting: '',
    data: {
      title: "",
      dateAndTime: "",
      attendees: [],
      agenda: []
    }
  });

  const [fullViewCancel, setFullViewCancel] = useState({
    isClicked: false,
    viewMore: false,
    typeOfMeeting: '',
    data: {
      title: "",
      date: "",
      time: "",
      attendees: [],
      agenda: [],
      startTime: "",
      endTime: "",
      cancelReason: "",
      cancelledByName: "",
    }
  });

  // ---------------------------------------------------------------------------Popup Utility----------------------------------------------------------------------
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [openFailModal, setOpenFailModal] = useState(false);
  const [failMessage, setFailMessage] = useState("");
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [reason, setReason] = useState("")
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [meetingToDelete, setMeetingToDelete] = useState({
    id: "",
    type: ""
  })

  const [idToCancelMeeting, setIdToCancelMeeting] = useState();
  const [cancelMeetingName, setCancelMeetingName] = useState("");


  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  const [agendaDivHeight, setAgendaDivHeight] = useState(false);
  const [msgDivHeight, setMsgDivHeight] = useState(false);
  const [agendaDivHeightCancel, setAgendaDivHeightCancel] = useState(false);
  const [attendeesDivHeight, setAttendeesDivHeight] = useState(false)

  useEffect(() => {
    handleOverflowCheck(setAttendeesDivHeight, setAgendaDivHeight, setMsgDivHeight, isOverflowing);
  }, [fullView]);


  useEffect(() => {
    setTimeout(() => {
      const div = document.getElementById("agenda_div");
      let res = isOverflowing(div)

      if (res) {
        setAgendaDivHeightCancel(res)
      }



    }, 1000);
  }, [fullViewCancel])





  

  // --------------------------------------------------------------------------Popup End--------------------------------------------------------------------------

  useEffect(() => {
    getDashboardData({
      setLoading,
      setData,
      setDataCopy,
      setSessionExpiredModal,
      setFailMessage,
      setOpenFailModal,
      POST,
      Url,
      token,
      selectedFromDate,
      selectedToDate
    });
  }, [selectedFromDate, selectedToDate]);

  useEffect(() => {
    handleSearch(searchInp, dataCopy, setData);
  }, [searchInp]);

  // const handleSearch = (inp) => {

  //   setData(
  //     dataCopy?.filter((i) => {
  //       return i?.meetingSubject?.toLowerCase().includes(inp?.toLowerCase());
  //     })
  //   );
  // };


  // -----------------------------------------------------------------------Handle Edit Functionallity---------------------------------------------------------------



  // -----------------------------------------------------------------------Handle View Functionallity---------------------------------------------------------------



  return (
    <div className="all-meeting-main" style={{}}>
      {
        data?.length == 0 ? (
          <div className="empty-card">
            No Records to show
          </div>
        )
          :
          
              data?.map((item) => {

                let AttendeesList = '';
                item?.participantsList?.map((i, index) => {
                  let lastitem = index + 1 == item?.participantsList?.length ? "" : ", ";

                  AttendeesList += i.fullName + lastitem;
                })

                const { to, from, optional } = getEmailClassification(item?.emailDetail);


                return (
                  <div className="all-meetings-card" style={{
                    borderLeft: item?.deptartmentTagMaster?.deptTag == "HR" ? "4px solid #1CA566"
                      : item?.deptartmentTagMaster?.deptTag == "IT" ? "4px solid  #4CB87C"
                        : item?.deptartmentTagMaster?.deptTag == "Governance" ? "4px solid  #057DAA" : "4px solid #FF9B00"
                  }}>
                    <div
                      className="allmeetings-subject-name">
                      {item?.meetingSubject}
                    </div>
                    <div
                      style={{
                        borderRight: "2px solid #00000029",
                        borderLeft: "2px solid #00000029",
                      }}
                    >
                      <div className="date-time-text" style={{ width: '100%' }}>
                        <p className="All-m-start-date-cont" style={{ fontSize: "13px", flexWeight: "600", width: "25%" }}>
                          Date
                        </p>
                        <p style={{ fontSize: 13, width: '15%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>:&nbsp;&nbsp;</p>
                        <p style={{ fontSize: 13, color: "#383838", width: '55%' }}>
                          {item?.parseStartDate}
                        </p>
                      </div>
                      <div className="date-time-text" style={{ width: '100%' }}>
                        <p className="All-m-start-date-cont" style={{ fontSize: "13px", flexWeight: "600", width: "25%" }}  >
                          Time
                        </p>
                        <p style={{ fontSize: 13, width: '15%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>:&nbsp;&nbsp;</p>
                        <p style={{ fontSize: 13, color: "#383838", width: '55%' }}>
                          {" "}
                          {item?.startTime} - {item?.endTime === "11:59 PM" ? "12:00 AM" : item?.endTime}
                        </p>
                      </div>
                      <div className="date-time-text" style={{ width: '100%' }}>
                        <p className="All-m-start-date-cont" style={{ fontSize: "13px", flexWeight: "600", width: "25%" }} >
                          Duration
                        </p>
                        <p style={{ fontSize: 13, width: '15%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>:&nbsp;&nbsp;</p>
                        <p style={{ fontSize: 13, color: "#383838", width: '55%' }}>{item?.duration}</p>
                      </div>
                    </div>
                    <div className="All-meeting-card-mom-cont"
                      style={{

                      }}
                    >
                      <div
                        className="date-time-text   All-meeting-card-inner-mom-cont"
                      >
                        {item?.typeOfMeeting == "Past" && (
                          <div className="all-meeting-card-reson-p-cont" style={{ width: '100%' }} >
                            <p className="All-m-mom-cont" style={{ fontSize: "13px", flexWeight: "600", width: "17%" }}>
                              MOM Status
                            </p>
                            <p style={{ fontSize: 13, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>:&nbsp;&nbsp;</p>
                            <p
                              className="attendees-text-wrap"
                            >
                              {item?.momStatus}
                            </p>
                          </div>
                        )}

                        {item?.typeOfMeeting == "Past" && (
                          <div className="all-meeting-card-reson-p-cont" style={{ width: '100%' }} >
                            <p className="All-m-mom-cont" style={{ fontSize: "13px", flexWeight: "600", width: "17%" }}>
                              Summary
                            </p>
                            <p style={{ fontSize: 13, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>:&nbsp;&nbsp;</p>
                            <p
                              className="attendees-text-wrap"
                            >
                              {(item?.meetingSummary) ? firstLineTextFromHtml(item?.meetingSummary) : "N/A"}
                            </p>
                          </div>
                        )}

                        {item?.typeOfMeeting == "Cancelled" && (
                          <div className="all-meeting-card-reson-p-cont" style={{ width: '100%' }}>
                            <p className="All-m-mom-cont" style={{ fontSize: "13px", flexWeight: "600", width: "17%" }}>
                              Reason
                            </p>
                            <p style={{ fontSize: 13, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>:&nbsp;&nbsp;</p>
                            <p
                              className="attendees-text-wrap"
                            >
                              {item?.cancelReason}
                            </p>
                          </div>
                        )}

                        {item?.typeOfMeeting == "Cancelled" && (
                          <div className="all-meeting-card-reson-p-cont" style={{ width: '100%' }} >
                            <p className="All-m-mom-cont" style={{ fontSize: "13px", flexWeight: "600", width: "17%" }} >
                              Cancelled By
                            </p>
                            <p style={{ fontSize: 13, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>:&nbsp;&nbsp;</p>
                            <p
                              style={{
                                fontSize: 13,
                                width: "80%",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                              }}
                            >
                              {item?.cancelledByName}
                            </p>
                          </div>
                        )}
                        {item?.typeOfMeeting === "Upcoming" && (
                          <div className="all-meeting-card-reson-p-cont" style={{ width: '100%' }}>
                            <p className="All-m-mom-cont" style={{ fontSize: "13px", fontWeight: "600", width: "17%" }}>
                              Attendees
                            </p>
                            <p style={{ fontSize: 13, display: 'flex', alignContent: 'center', justifyContent: 'center' }}>:&nbsp;&nbsp;</p>
                            <p className="attendees-text-wrap">
                              {/* {item?.emailDetails?.[0]?.attendees} */}
                              {AttendeesList}
                            </p>
                          </div>
                        )}
                        {item?.typeOfMeeting == "Upcoming" && (
                          <div className="all-meeting-card-reson-p-cont" style={{ width: '100%' }}>
                            <p className="All-m-mom-cont" style={{ fontSize: "13px", flexWeight: "600", width: "17%" }}>
                              Agenda
                            </p>
                            <p style={{ fontSize: 13, display: 'flex', alignContent: 'center', justifyContent: 'center' }}>:&nbsp;&nbsp;</p>
                            <p
                              className="attendees-text-wrap"
                            > {!(item?.meetingAgenda.trim().length === 0) ?
                              firstLineTextFromHtml(item?.meetingAgenda) : "Not Available"}
                            </p>
                          </div>
                        )}
                      </div>

                      <div
                        className="All-meetings-action-btn-cont"
                      >
                        <div className="action-buttons"
                          data-testid="action-button-view"
                          id={(item?.typeOfMeeting == "Past" && item?.meetingSummary) ? "normal" : item?.typeOfMeeting == "Upcoming" ? "normal" : item?.typeOfMeeting == "Cancelled" ? "normal" : "disabled"}
                          onClick={() =>
                            handleMeetingClick({
                              item,
                              handleViewMeeting,
                              handleOpenFullView,
                              handleOpenFullViewCancel,
                              setViewPastMeeting,
                              setFullView,
                              setAllUpcommingMeetOpenView,
                              setAllCancelMeetOpenView,
                              setFullViewCancel,
                              setLoading,
                              extractMeetingData,
                            })
                          }>
                          <BsEye fill="#00ADEE" size={14} />
                        </div>

                        <div className="action-buttons"
                          data-testid="action-button-edit"
                          id={
                            item?.typeOfMeeting === "Past"
                              ? hasAccess(item) ? "normal" : "disabled"
                              : (from[0]?.participantEmail !== usermail)
                                ? "disabled"
                                : "normal"
                          }
                          onClick={() =>
                            processMeetingClick({
                              item,
                              from,
                              navigate,
                              hasAccess,
                              usermail,
                              handleEditMeeting,
                            })
                          }
                        >
                          {item?.typeOfMeeting == "Cancelled" ? <MdSchedule fill="#00ADEE" /> : <SlPencil fill="#00ADEE" size={13} />}
                        </div>
                        <div className="action-buttons"
                          data-testid="action-button-cancel"
                          id={
                            (item?.typeOfMeeting === "Past")
                              ? (item?.meetingSummary ? "normal" : "disabled")
                              : (from[0]?.participantEmail !== usermail)
                                ? "disabled"
                                : "normal"
                          }
                          onClick={() =>
                            handleMeetingActions({
                              item,
                              from,
                              usermail,
                              setFailMessage,
                              setOpenCancelModal,
                              setIdToCancelMeeting,
                              setCancelMeetingName,
                              setOpenDeleteModal,
                              setMeetingToDelete,
                              GeneratePDF,
                            })
                          }>
                          {
                            item?.typeOfMeeting == "Upcoming" ? <AiOutlineClose fill="#00ADEE" size={14} /> : item?.typeOfMeeting == "Cancelled" ? <AiOutlineDelete fill="#00ADEE" size={14} /> : <BsDownload fill='#00ADEE' size={12} />

                          }
                        </div>

                      </div>
                    </div>
                    <div className="tag-wraper">
                      <div className="corner-tag" style={{ backgroundColor: item?.typeOfMeeting == "Upcoming" ? "#00AFF1" : item?.typeOfMeeting == "Past" ? "#999999" : item?.typeOfMeeting == "Cancelled" ? "#F9464F" : "" }}>{item?.typeOfMeeting}</div>
                    </div>
                  </div>
                );
              })
      }


      {/* -----------------------Cancel Meeting Full View Modal ---------------------------------------------------------- */}



      <CancelledMeetingModal
        isOpen={AllcancelMeetOpenView}
        onRequestClose={() => handleAllMCloseModalOnRequest(setAllCancelMeetOpenView, setAgendaDivHeightCancel)}
        customStyles={customStyles}
        fullView={fullViewCancel}
        setFullView={setFullViewCancel}
        agendaDivHeight={agendaDivHeightCancel}
        extractTextFromHtml={stripHtmlTags}
      />

      {/* -----------------------------Upcoming Meeting Full view Modal --------------------------------------------------- */}


      <UpcomingMeetingModal
        isOpen={AllUpcommingMeetOpenView}
        onRequestClose={() => handleAllMCloseOnRequest(setAllUpcommingMeetOpenView, setAgendaDivHeight, setMsgDivHeight, setAttendeesDivHeight)}
        customStyles={customStyles}
        fullView={fullView}
        setFullView={setFullView}
        setAgendaDivHeight={setAgendaDivHeight}
        setMsgDivHeight={setMsgDivHeight}
        setAttendeesDivHeight={setAttendeesDivHeight}
        attendeesDivHeight={attendeesDivHeight}
        agendaDivHeight={agendaDivHeight}
        msgDivHeight={msgDivHeight}
        stripHtmlTags={stripHtmlTags}
      />


      {/* ---------------------------------------------------------------------------------POPUPS------------------------------------------------------- */}


      <FailModal
        openFailModal={openFailModal}
        setOpenFailModal={setOpenFailModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() => handleCloseFailModel(setOpenFailModal)}
        recallFunctiononClose={() => handleCloseFailModel(setOpenFailModal)}
      />

      {/* //////////////POPUP for delete */}
      <FailModal
        openFailModal={openDeleteModal}
        setOpenFailModal={setOpenDeleteModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() => {
          handleDeleteMeeting({
            setOpenDeleteModal,
            setLoading,
            meetingToDelete,
            DELETE,
            Url,
            token,
            setSuccessMessage,
            setOpenSuccessModal,
            toggleForCount,
            setToggleForCount,
            setSessionExpiredModal,
            setFailMessage,
            setOpenFailModal
          });
        }}
        recallFunctiononClose={() => handleCloseFailModel(setOpenFailModal)}
      />
      {/* session expire modal */}
      <FailModal
        openFailModal={sessionExpiredModal}
        setOpenFailModal={setSessionExpiredModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() => handleSessionExpClose(navigate, setActive)}
        recallFunctiononClose={() => handleSessionExpClose(navigate, setActive)}
      />
      {/* openSuccessModal, setOpenSuccessModal, successMessage, setSuccessMessage, recallFunctionOnOk, recallFunctionOnClose */}
      <SuccessModal
        openSuccessModal={openSuccessModal}
        setOpenSuccessModal={setOpenSuccessModal}
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
        recallFunctionOnOk={()=>{getDashboardData({
          setLoading,
          setData,
          setDataCopy,
          setSessionExpiredModal,
          setFailMessage,
          setOpenFailModal,
          POST,
          Url,
          token,
          selectedFromDate,
          selectedToDate
        })}}
        recallFunctionOnClose={() => handleCloseSuccessModal(setOpenSuccessModal)}
      />
      <CancelReason
        openReasonModal={openCancelModal}
        setOpenReasonModal={setOpenCancelModal}
        reasonState={reason}
        setReasonState={setReason}
        reasonChangeFunction={reasonChange}
        meetingName={cancelMeetingName}
        CancelledBy={username}
        recallFunctionOnOk={() => {
          handleCancel({
            idToCancelMeeting,
            reason,
            setLoading,
            setOpenCancelModal,
            setSuccessMessage,
            setOpenSuccessModal,
            setToggleForCount,
            setFailMessage,
            setOpenFailModal,
            setSessionExpiredModal
          })
        }}
        recallFunctiononClose={() => handleCloseCancleModal(setOpenCancelModal)}
        setReason={setReason}
      />
    </div>
  );
};

export default AllMeetings;



